import DetalleHorario from 'components/horarios/DetalleHorario'
import React from 'react'
import {  Col, Row } from 'reactstrap'

const ViewDetalleHorarios = () => {
  return (
    <>
     <Row>
        <Col>
            <DetalleHorario></DetalleHorario>
        </Col>
     </Row>
    </>
  )
}

export default ViewDetalleHorarios